import React from "react";
import { Link } from "react-router-dom";
import { AppLogo } from "@/components/ui/AppLogo";

export function PublicNavbar({ dark = false }) {
  // Note: 'dark' flag retained for backward compatibility; we now always render
  // the same landing-aligned light bar so the brand stays consistent everywhere.
  const _ = dark; // ignored
  return (
    <header
      data-testid="public-navbar"
      className="sticky top-0 z-50 bg-[#FBFAF7]/85 backdrop-blur-xl border-b border-black/5"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <AppLogo size="md" />
        <nav className="hidden md:flex items-center gap-9 text-[13.5px] text-neutral-700">
          <a href="/#platform" className="hover:text-black">Platform</a>
          <a href="/#ai" className="hover:text-black">AI</a>
          <a href="/#scale" className="hover:text-black">For scale</a>
          <a href="/#pricing" className="hover:text-black">Pricing</a>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/login" data-testid="login-link" className="hidden sm:block text-[13.5px] font-medium hover:text-black/70">Sign in</Link>
          <Link
            to="/signup"
            data-testid="signup-cta"
            className="text-[13.5px] font-semibold bg-[#0A0C10] text-[#FBFAF7] px-4 py-2 rounded-full hover:bg-black transition-colors"
          >
            Start for free →
          </Link>
        </div>
      </div>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="bg-[#0A0C10] text-neutral-400 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-5 gap-8 text-sm">
        <div className="col-span-2">
          <div className="text-white font-display font-bold text-xl mb-3">TeachingSoftware<span className="text-[#FFB400]">.ai</span></div>
          <p className="max-w-sm">The AI-powered operating system for online teachers. Manage students, schedule classes, generate quizzes & lessons, run live sessions, and grow your tuition business.</p>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">Product</div>
          <ul className="space-y-2">
            <li><a href="/#features">Features</a></li>
            <li><a href="/#ai">AI tools</a></li>
            <li><a href="/#pricing">Pricing</a></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">Solutions</div>
          <ul className="space-y-2">
            <li><Link to="/landing/ai-teaching-software">AI teaching software</Link></li>
            <li><Link to="/landing/online-tuition-software">Online tuition software</Link></li>
            <li><Link to="/landing/lms-for-online-teachers">LMS for online teachers</Link></li>
            <li><Link to="/landing/virtual-classroom-software">Virtual classroom</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">Company</div>
          <ul className="space-y-2">
            <li><a href="#">About</a></li>
            <li><a href="#">Blog</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-xs text-neutral-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-2 font-mono uppercase tracking-[0.16em] text-[11px]">
          <div className="inline-flex items-center gap-2">
            <span>© 2026 TeachingSoftware.ai</span>
            <span className="text-neutral-700">·</span>
            <span>A <a
              href="https://www.cloudlabweb.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cloudlab-link"
              className="underline underline-offset-4 decoration-[#FFB400]/60 hover:text-[#FFB400] transition-colors"
            >Cloud Lab Technologies</a> product</span>
            <span className="text-neutral-700">·</span>
            <span>UK</span>
          </div>
          <div className="inline-flex items-center gap-2 text-neutral-600">
            <span className="w-1.5 h-1.5 bg-[#FFB400] inline-block" />
            <span>The AI Teaching OS</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
